// extracted by mini-css-extract-plugin
export var card = "PodcastCard-module--card--f3e3d";
export var contentWrapp = "PodcastCard-module--contentWrapp--381ea";
export var flex = "PodcastCard-module--flex--a1447";
export var imgWrapp = "PodcastCard-module--imgWrapp--8f4e4";
export var player = "PodcastCard-module--player--b8139";
export var title = "PodcastCard-module--title--b84be";